import React, { useContext } from "react";
import { MDBSideNavItem, MDBSideNavLink, MDBSideNavCollapse, MDBIcon } from "mdb-react-ui-kit";
import { ThemeContext } from "../../../Context/ThemeContext.js";

const CollapsibleNavigationItem = ({ icon, label, children, isOpen, setSectionOpenStatus }) => {
  const { isDarkUi } = useContext(ThemeContext);
  const themeClass = isDarkUi ? "dark" : "";
  return (
  <MDBSideNavItem>
    <MDBSideNavLink icon="angle-down" className={themeClass} shouldBeExpanded={isOpen} onClick={() => setSectionOpenStatus(!isOpen)}>
      <MDBIcon fas icon={icon} className="fa-fw me-3" />
      {label}
    </MDBSideNavLink>
    <MDBSideNavCollapse open={isOpen}>
      {children}
    </MDBSideNavCollapse>
  </MDBSideNavItem>
  );
};

export default CollapsibleNavigationItem;
